// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-qUEFf{margin:0 !important}`, "",{"version":3,"sources":["webpack://./src/layout/navigation/navActions/LivestreamNav/livestreamNav.module.scss"],"names":[],"mappings":"AAAA,YACI,mBAAA","sourcesContent":[".link {\n    margin: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `link-qUEFf`
};
export default ___CSS_LOADER_EXPORT___;
